<template>
    <label class="formkit-label self-record-form-label" for="branch">Офис</label>
    <v-select
        ref="select"
        class="search"
        :class="{'open-class': openClass}"
        v-model="selectBranch"
        @open="openClass = true"
        @close="openClass = false"
        :options="storeBranchList"
        name="branch"
        label="label"
        :loading="isBranchesLoading"
    >
        <template #no-options>
            Офис не найден
        </template>
    </v-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'SelectBranch',
    props: ['branch'],
    computed: {
        ...mapGetters({
            storeBranch: 'getBranch',
            storeBranchList: 'getBranchList'
        })
    },
    watch: {
        selectBranch(newSelectBranch) {
            this.$emit('update:branch', newSelectBranch);
        }
    },
    data: () => {
        return {
            selectBranch: '',
            isBranchesLoading: false,
            openClass: false
        }
    },
    methods: {
        ...mapActions(['fetchOffices']),
        async loadBranches () {
            this.isBranchesLoading = true;
            await this.fetchOffices().then(() => {
                this.selectBranch = Object.keys(this.storeBranch).length 
                    ? this.storeBranchList.find(office => office.value.city_id === this.storeBranch.city_id) 
                    : this.storeBranchList[0];
            }).finally(() => {
                this.isBranchesLoading = false;
            });
        }
    },
    async beforeMount() {
        await this.loadBranches();
    }
}
</script>

<style lang="scss" scoped>
.open-class {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
</style>